import { Pipe, PipeTransform } from '@angular/core';
import { FormlyTemplateOptions } from '@ngx-formly/core';

@Pipe({
  name: 'autocompleteValueParser'
})
export class AutocompleteValueParserPipe implements PipeTransform {
  transform(value: any, to: FormlyTemplateOptions, funcName: string): any {
    if (typeof to[funcName] === 'function') {
      return to[funcName](value);
    }
    return value;
  }
}
